var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingPercent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 22,
    viewBox: "0 0 492 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.994 0.736572H10.8663C5.12282 0.736572 0.5 5.35939 0.5 11.1029C0.5 16.8464 5.12282 21.4692 10.8663 21.4692H481.134C486.877 21.4692 491.5 16.8464 491.5 11.1029C491.5 5.49947 486.877 0.736572 480.994 0.736572Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.5 0.736572H8.3461C3.99893 0.736572 0.5 5.419 0.5 11.2366C0.5 17.0541 3.99893 21.7366 8.3461 21.7366H350.5V0.736572Z",
    fill: "#fed304"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.922 0.736572H10.8657C6.66309 0.736572 3.02087 3.2581 1.33984 6.90033H24.0337H463.062V0.736572H462.922Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5234_576490",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 492,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M480.994 0.736572H10.8663C5.12282 0.736572 0.5 5.35939 0.5 11.1029C0.5 16.8464 5.12282 21.4692 10.8663 21.4692H481.134C486.877 21.4692 491.5 16.8464 491.5 11.1029C491.5 5.49947 486.877 0.736572 480.994 0.736572Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5234_576490)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05183 30.4347H0.779297L16.6005 -5.84741H24.873L9.05183 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7667 30.4347H22.4941L38.3154 -5.84741H46.5879L30.7667 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4815 30.4347H44.209L60.0302 -5.84741H68.3027L52.4815 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1983 30.4347H65.9258L81.6436 -5.84741H90.0195L74.1983 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9131 30.4347H87.5371L103.358 -5.84741H111.734L95.9131 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.628 30.4347H109.252L125.073 -5.84741H133.346L117.628 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.239 30.4347H130.967L146.788 -5.84741H155.061L139.239 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.956 30.4347H152.684L168.505 -5.84741H176.777L160.956 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.671 30.4347H174.398L190.22 -5.84741H198.492L182.671 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.386 30.4347H196.113L211.935 -5.84741H220.207L204.386 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.101 30.4347H217.828L233.649 -5.84741H241.922L226.101 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.817 30.4347H239.545L255.366 -5.84741H263.639L247.817 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.532 30.4347H261.26L277.081 -5.84741H285.354L269.532 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.247 30.4347H282.975L298.796 -5.84741H307.068L291.247 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.962 30.4347H304.689L320.511 -5.84741H328.783L312.962 30.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.679 30.4347H326.406L342.227 -5.84741H350.5L334.679 30.4347Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingPercent);
export default __webpack_public_path__ + "static/media/loading_percent.fc5f57c7b4e2a07359f4205321e053a7.svg";
export { ForwardRef as ReactComponent };